window.onload = function() {
    if (window.jQuery) {  
        // jQuery is loaded  
        console.log("jQuery loaded");
    } else {
        // jQuery is not loaded
        console.log("jQuery not loaded");
    }
} // window.onload



$(window).load(function() {
//$(document).ready(function() {

	// Get URL Path
	var vTitle = window.location.pathname.split("/").pop();
	console.log("vTitle = " + vTitle);

	//bracelet
	//keychain
	//lanyard
	//necklace
	if((vTitle == "hockey-tournament-necklace")||(vTitle == "hockey-family")||(vTitle == "hockey-lace-necklaces-bracelets-keychains-lanyards")) {
		var myFirstImageArray = ["firstLoad.png","Select.png","Select.png","Select.png","Select.png"];
		var myFirstFolderArray = ["bg","lace","second-color","slip-covers","third-color"];
		addConfigurator("necklace", myFirstImageArray, myFirstFolderArray);
	}

	//singlestrandlanyard
	if(vTitle == "hockey-tournament-lanyards") {
		var myFirstImageArray = ["ice.png","Select.png","Select.png"];
		var myFirstFolderArray = ["bg","lace","slip-covers"];
		$('#advancedCustomProducts').before($('#digitaldraping-singlestrandlanyard'));
		addConfigurator("singlestrandlanyard", myFirstImageArray, myFirstFolderArray);	
	}
		
	//loopedbracelet
	if(vTitle == "bulk-order-hockey-lace-bracelets-by-swannys") {
		var myFirstImageArray = ["ice.png","Select.png","Select.png"];
		var myFirstFolderArray = ["bg","lace","slip-covers"];
		$('#advancedCustomProducts').before($('#digitaldraping-loopedbracelet'));
		addConfigurator("loopedbracelet", myFirstImageArray, myFirstFolderArray);
	}
	
	//stuffedhockeynecklace
	if(vTitle == "hockey_necklaces_cheap_bulk_tournament") {
		var myFirstImageArray = ["ice.png","Select.png","Select.png"];
		var myFirstFolderArray = ["bg","lace","slip-covers"];
		$('#advancedCustomProducts').before($('#digitaldraping-stuffedhockeynecklace'));
		addConfigurator("stuffedhockeynecklace", myFirstImageArray, myFirstFolderArray);
	}
		
		

	function addConfigurator(name, myFirstImageArray, myFirstFolderArray) {
		var myFolder = name;
		var myTempFolder = "";
		var myTempImage = "";
		var flag = "yes";
		
		
		jQuery('body').on('mw_apo', function (event, action) {
		
		    if (action === 'end-initialize') {
			  	
			  	$(".mw-option-select").children("select").on('change', function() {

					var temp = $(this).val();
					
			  		myTempFolder = $(this).parent("div").children("input").attr("name");
			  		console.log("myTempFolder - " + myTempFolder);
			  		if (myTempFolder != "properties[Size]") {

			  			if (myTempFolder == "properties[Product]") {
			  				myFolder = temp.toLowerCase();
			  				console.log("myFolder - " + myFolder);
			  				my.baseImageFolder = myFolder;
				  			flag = "no";
			  			}else {
				  		  	myTempFolder = correctName(myTempFolder);
				  		  	console.log("myTempFolder - " + myTempFolder);
				  		  	
				  		  	myTempImage = temp;
				  		  	myTempImage = correctName(myTempImage);
				  		  	console.log("myTempImage - " + myTempImage);
				  		  	flag = "yes";
			  		  	}

			  		updateImage(myTempFolder,myTempImage);
			  		}
			  	})		
		    }
		});
		
		function correctName(name) {
			
			if (name == "properties[Hockey Lace Color]") {
				return "lace";
			}
			if (name == "properties[S/C Color]") {
				return "slip-covers";
			}
			if (name == "properties[Color 2]") {
				return "second-color";
			}
			if (name == "properties[Color 3]") {
				return "third-color";
			}
			
			name = name.replace(" Hockey", "");
			name = name.replace(" ", "-");
			name = name.replace("Carolina-Blue", "Carolina-Blue-Hockey");
			name = name.replace("Navy-Blue", "Navy");
			name = name.replace("Royal-Blue", "Royal");
			name = name.replace("Vegas-Gold", "Vegas");
			name = name.replace("Gray(dark)", "Gray-Dark");
			name = name.replace("Gray(light)", "Gray-Light");
			name = name.replace("Gray(light)", "Gray-Light");
			name = name.replace("Gold(yellow)", "Gold");
			
			
			return name;
		}

		var my = {
		    imageArray:myFirstImageArray,
			folderArray:myFirstFolderArray,
			baseImageFolder:myFolder,	
			returnType:"1",
		    size:"small",
			folder:"../",
			quality:"92",
		    resize:"0",
		    smallImageW:"900",
			smallImageH:"506",
			largeImageW:"900",
			largeImageH:"506"
		};
		
		function getString() {
			return "myReturnType=" + my.returnType +
			"&mySize=" + my.size +
			"&myFolder=" + my.folder +
			"&myQuality=" + my.quality +
			"&myResize=" + my.resize +
			"&mySmallImageW=" + my.smallImageW +
			"&mySmallImageH=" + my.smallImageH +
			"&myLargeImageW=" + my.largeImageW +
			"&myLargeImageH=" + my.largeImageH +
			"&myBaseImageFolder=" + my.baseImageFolder +
			"&myImageArray=" + my.imageArray +
			"&myFolderArray=" + my.folderArray;
		}
	
		function updateImage(myTempFolder,myTempImage) {
			console.log("my.imageArray" + my.imageArray);
			console.log("my.folderArray" + my.folderArray);
			if (flag == "yes") {
				if (myTempImage == "") {
						myTempImage = "Select";
					}
				var myTempFolderPosition = jQuery.inArray(myTempFolder, my.folderArray);
				console.log("myTempFolderPosition - " + myTempFolderPosition);
				my.imageArray.splice(myTempFolderPosition,1,myTempImage+".png");
			}
			
			if (my.imageArray[0]!="ice.png") {
				my.imageArray[0] = "ice.png"
			}
			$("#myImage").empty();
			$("#myImage").append("<img src='https://swannys.digitaldraping.com/_img/loading.gif'>");
			mergeMyImages();
			console.log("my.imageArray" + my.imageArray);
			console.log("my.folderArray" + my.folderArray);
		}		
		
//Return Number 1
		function mergeMyImages() {
		    $.ajax({
				type: "POST",
				url: "https://swannys.digitaldraping.com/_php/merge.php?",
				data: getString(),
		        success: function(data){
					$("#myImage").empty();
					$("#myImage").append(data);
					console.log("loaded");
				}
		    });
		} 
		
		mergeMyImages();
	
	} // addConfigurator

	
}); // $(window).load(function()